import { type Translation } from "./en";

export const uk: Translation = {
  ai_speech_preview_free_title: "Стандартний голос",
  ai_speech_preview_free_desc: "Безкоштовний роботизований голос",
  ai_speech_preview_pro_desc: "Високоякісний голос з природною інтонацією",
  ai_speech_preview_free_lbl: "Безкоштовно",
  ai_speech_lang_support: "Підтримує понад 30 мов",
  ai_speech_listen: "Прослухати зразок",
  voice_type_none: "Немає",
  review_custom: "Виберіть, що повторити",
  review_card_type: "Тип картки",
  custom_due_cards: "Картки для повторення",
  custom_new_cards: "Нові картки",
  go_back: "Назад",
  settings_lang: "Мова",
  copy_code: "Копіювати код",
  copied: "Скопійовано",
  html_column: "Стовпець",
  html_row: "Рядок",
  logout: "Вийти",
  error_contact_support:
    "Сталася помилка. Будь ласка, зв'яжіться з підтримкою, щоб ми могли вам допомогти.",
  ai_card_input_mode_supports: "Підтримує різні мови",
  browser_no_personal_decks_start: "У вас ще немає персональних колод",
  browser_no_personal_decks_end: ". Успішного навчання! 😊",
  browser_no_personal_decks_link: "Дізнайтеся, як користуватися MemoCard у ",
  upgrade_pro: "Оновити до Pro",
  login_google: "Увійти через Google",
  youtube_channel: "YouTube канал",
  card_input_mode_changed: "Режим введення картки змінено",
  card_input_mode_manual: "Ручне введення",
  card_input_mode_get: "ви отримаєте картку, як ця",
  card_input_mode_type: "Якщо ви введете",
  card_input_mode_screen: "Режим введення картки",
  generate: "Згенерувати",
  yes: "Так",
  ai_speech_validate: "Будь ласка, виберіть сторону або введіть текст",
  ai_speech_type: "Або введіть потрібний текст",
  ai_speech_empty: "ШІ мовлення не створено. Виберіть сторону картки нижче.",
  ai_speech_title: "ШІ мовлення",
  ai_speech_generate: "Згенерувати",
  confirm_ok: "Підтвердити",
  confirm_cancel: "Скасувати",
  payment_success:
    "Оплату успішно здійснено. Насолоджуйтесь додатковими можливостями 😊",
  payment_failed:
    "Оплата не вдалася. Ми знаємо про проблему і працюємо над нею. Будь ласка, зв'яжіться з підтримкою через Налаштування > Підтримка.",
  user_settings_updated: "Налаштування оновлено",
  is_off: "Вимкнено",
  is_on: "Увімкнено",
  folder_form_no_decks: "У папці немає колод",
  card_next: "Наступна",
  card_previous: "Попередня",
  ui_loading: "Завантаження...",
  yes_no: "Пам'ятаю",
  card_answer_type: "Тип картки",
  answer_type_explanation_choice: "Картка з варіантами відповідей",
  answer_type_explanation_remember:
    "Картка з кнопками 'Пам'ятаю' та 'Не пам'ятаю'",
  answer_type_choice: "Тест",
  profile_section: "Профіль",
  folder_form_quit_card_confirm: "Вийти з редагування папки без збереження?",
  read_more: "Читати далі",
  review_idk: "Не знаю",
  review_again: "Знову",
  review_hard: "Важко",
  review_good: "Добре",
  review_easy: "Легко",
  user_stats_empty_text: "Вивчіть більше карток, щоб побачити дані",
  hide_card_forever: "Приховати назавжди",
  mute_cards: "Вимкнути звук",
  unmute_cards: "Увімкнути звук",
  hide_card_forever_confirm_title:
    "Ви впевнені, що хочете приховати цю картку назавжди? Ви більше її не побачите",
  next: "Далі",
  payment_tos_and_pp_agree: "Купуючи MemoCard, ви погоджуєтеся з ",
  payment_pp: "Політикою конфіденційності",
  privacy_policy: "Політика конфіденційності",
  payment_and: " та ",
  payment_tos: "Умовами використання",
  payment_paid_until: "Оплачено до",
  payment_description: "Розблокуйте більше можливостей",
  payment_choose_duration: "Тривалість",
  payment_method_usd: "Банківська картка",
  payment_choose_method: "Спосіб оплати",
  payment_choose_subscription: "Підписка",
  payment_method_stars: "Telegram зірки",
  payment_included: "Що включено",
  ai_cards_left: "Залишилось ШІ карток цього місяця",
  wysiwyg_bold: "Жирний",
  wysiwyg_undo: "Скасувати",
  repeat_cards_anyway: "Повторити все одно",
  wysiwyg_big_header: "Великий заголовок",
  wysiwyg_text_color: "Колір тексту",
  wysiwyg_clear_formatting: "Очистити форматування",
  wysiwyg_italic: "Курсив",
  formatting: "Форматування",
  validation_at_least_one_deck: "Будь ласка, виберіть хоча б 1 колоду",
  duplicate_folder_confirm: "Ви впевнені, що хочете дублювати цю папку?",
  validation_at_least_one_answer_required:
    "Потрібно надати хоча б одну відповідь",
  review_correct_label: "Правильно",
  review_wrong_label: "Неправильно",
  validation_answer_at_least_one_correct:
    "Потрібно вибрати одну правильну відповідь",
  advanced: "Розширені",
  answer_text: "Текст відповіді",
  add_answer: "Додати відповідь",
  card_preview: "Перегляд",
  review_folder: "Повторити папку",
  folder_description: "Колекція колод",
  add_deck_short: "Колода",
  folder: "Папка",
  deck_description: "Колекція карток",
  deck: "Колода",
  edit_folder: "Редагувати папку",
  add_folder: "Додати папку",
  add_deck_to_folder: "Додати колоду до папки",
  decks_in_other_folders: "Колоди в інших папках",
  no_decks_to_add: "Немає більше колод для додавання",
  decks: "Колоди",
  my_decks: "Мої колоди",
  show_all_decks: "Показати всі",
  hide_all_decks: "Приховати",
  select_all: "Вибрати все",
  deselect_all: "Зняти виділення",
  select: "Вибрати",
  selected: "Вибрано",
  add_deck: "Додати колоду",
  deck_form_remove_card_confirm:
    "Ви впевнені, що хочете видалити картку? Всі перегляди картки від усіх користувачів буде втрачено",
  deck_form_remove_cards_confirm:
    "Ви впевнені, що хочете видалити всі вибрані картки?",
  edit_deck: "Редагувати колоду",
  edit_card: "Редагувати картку",
  add: "Додати",
  edit: "Редагувати",
  view: "Переглянути",
  all_decks_reviewed:
    "Чудова робота! 🌟 Ви переглянули всі колоди. Поверніться пізніше за більшим.",
  public_decks: "Публічні колоди",
  explore_public_decks: "Знайти більше колод",
  news_and_updates: "Новини та оновлення",
  telegram_channel: "Telegram канал",
  settings: "Налаштування",
  deck_has_been_added: "Ця колода вже у вашому списку",
  deck_catalog: "Каталог колод",
  translated_to: "Перекладено на",
  any_language: "Будь-яка мова",
  category: "Категорія",
  any_category: "Будь-яка",
  deck_search_not_found: "Колод не знайдено",
  card_search_not_found: "Карток не знайдено",
  deck_search_not_found_description:
    "Спробуйте оновити фільтри, щоб побачити більше",
  category_English: "Англійська",
  category_Other: "Інше",
  category_Thai: "Тайська",
  category_Geography: "Географія",
  category_History: "Історія",
  category_Chemistry: "Хімія",
  category_Spanish: "Іспанська",
  save: "Зберегти",
  add_card: "Додати картку",
  card_front_title: "Лицьова сторона",
  card_back_title: "Зворотна сторона",
  card_front_side_hint: "Підказка або питання",
  card_back_side_hint: "Відповідь, яку потрібно надати",
  card_field_example_title: "Приклад",
  card_field_example_hint: "Додаткова інформація (необов'язково)",
  cards: "Картки",
  search_card: "Пошук картки",
  card_sort_by_date: "Дата",
  card_sort_by_front: "Лицьова сторона",
  card_sort_by_back: "Зворотна сторона",
  sort_by: "Сортувати за",
  title: "Назва",
  description: "Опис",
  speaking_cards: "Картки з озвучкою",
  voice_language: "Мова озвучки",
  card_speak_side: "Сторона картки",
  front: "Лицьова",
  back: "Зворотна",
  card_speak_description:
    "Відтворювати аудіо для кожної картки, щоб слухати вимову",
  review_deck_finished: "Ви завершили цю колоду 🎉",
  review_all_cards: "Ви повторили всі картки на сьогодні 🎉",
  review_finished_want_more: "Хочете більше? У вас є",
  review_finished_to_review: "для вивчення",
  review_deck: "Повторити колоду",
  cards_to_repeat: "Повторити",
  cards_new: "Нові картки",
  cards_total: "Всього карток",
  duplicate: "Дублювати",
  duplicate_deck_confirm: "Ви впевнені, що хочете дублювати цю колоду?",
  delete_deck_confirm_shared: "Видалити колоду з вашої колекції?",
  delete_folder_confirm_shared: "Видалити папку з вашої колекції?",
  delete_deck_confirm_author:
    "Видалити колоду з MemoCard? Цю дію не можна скасувати",
  delete_folder_confirm_author:
    "Видалити папку з MemoCard? Цю дію не можна скасувати",
  delete: "Видалити",
  no_cards_to_review_in_deck:
    "Чудова робота! 🌟 Ви переглянули всі картки в цій колоді. Поверніться пізніше за більшим.",
  no_cards_to_review_all:
    "Чудова робота! 🌟 Ви повторили всі картки на сьогодні. Поверніться пізніше за більшим.",
  review_show_answer: "Показати відповідь",
  share: "Поділитися",
  warning_telegram_outdated_title: "Ваш Telegram застарів",
  warning_telegram_outdated_description:
    "Будь ласка, оновіть Telegram для стабільної роботи цього додатка.",
  settings_review_notifications: "Нагадування про повторення",
  settings_time: "Час",
  settings_review_notifications_hint:
    "Щоденні нагадування допомагають не забувати повторювати картки",
  validation_deck_title: "Назва колоди обов'язкова",
  deck_form_quit_card_confirm: "Вийти з редагування картки без збереження?",
  quit_without_saving: "Вийти без збереження?",
  deck_form_quit_deck_confirm: "Вийти з редагування колоди без збереження?",
  deck_category: "Категорія колоди",
  validation_required: "Це поле обов'язкове",
  share_link_copied: "Посилання скопійовано в буфер обміну",
  settings_contact_support: "Зв'язатися з підтримкою в Telegram",
  settings_support_hint: "Якщо у вас є проблеми, питання чи пропозиції",
  user_stats_btn: "Статистика",
  user_stats_page: "Моя статистика",
  user_stats_remembered: "Запам'ятовано",
  user_stats_remembered_hint: "Натиснуто 'Пам'ятаю' 5 разів поспіль",
  user_stats_learning: "У процесі вивчення",
  user_stats_learning_hint: "Натиснуто 'Пам'ятаю' менше 5 разів поспіль",
  user_stats_total: "Всього карток",
  user_stats_total_hint: "Картки, відкриті хоча б один раз",
  user_stats_learning_time: "Розподіл часу навчання",
  user_stats_learning_time_hint:
    "Як розподіляється ваш час між вивченням нового матеріалу та повторенням",
  user_stats_chart_min_expl: "Не знаю картку",
  user_stats_chart_max_expl: "Знаю картку дуже добре",
  validate_positive: "Будь ласка, введіть додатне число",
  validate_under_100: "Будь ласка, введіть число менше 100",
  freeze_confirm_freeze:
    "Ви впевнені, що хочете заморозити свої картки? Цю дію не можна скасувати.",
  freeze_title: "Заморозити картки",
  how: "Як це працює",
  freeze_rule_1:
    "Всі ваші картки буде призупинено, і ви не отримуватимете сповіщень.",
  freeze_rule_2:
    "Кількість карток для повторення не зростатиме протягом замороженого періоду; ви побачите ту саму кількість карток, коли відновите навчання.",
  freeze_rule_3: "Заморожування карток не можна скасувати.",
  freeze_rule_4:
    "Якщо ви додасте картку під час періоду заморозки, вона не буде зачеплена заморозкою.",
  freeze_for: "Заморозити на",
  freeze_for_or_manual: "або введіть вручну",
  freeze_notified: "Ви отримаєте сповіщення",
  freeze_hint: "Відкласти вивчення карток",
  error_solving: "Ми вирішуємо проблему",
  error: "Помилка",
  ai_cards_generate: "Згенерувати картки",
  ai_cards_title: "Створення карток за допомогою ШІ",
  ai_cards_previous_prompts: "Історія запитів",
  ai_cards_no_previous_prompts: "Немає попередніх запитів",
  ai_cards_prompt: "Опис",
  ai_cards_prompt_front: "Опис лицьової сторони",
  ai_cards_prompt_back: "Опис зворотної сторони",
  ai_cards_by_ai: "Картки, створені ШІ",
  ai_cards_confirm_delete: "Видалити цю картку?",
  ai_cards_added: "Картки додано",
  ai_cards_use_template: "Використати шаблон",
  cards_add: "Додати картки",
  add_card_short: "Додати картку",

  // Global Search
  global_search_placeholder: "Пошук колод, папок, карток",
  global_search_no_results: "Нічого не знайдено",
  global_search_cancel: "Скасувати",
  global_search_start_typing:
    "Почніть вводити текст для пошуку колод, папок та карток",
  global_search_tabs_cards: "Картки",
  global_search_tabs_decks: "Колоди",
  global_search_tabs_folders: "Папки",
  global_search_context_folder: "Папка",
  global_search_context_deck: "Колода",

  // About page
  about_title: "Про додаток",
  about_paragraph_1:
    "MemoCard з'явився тому, що існуючі додатки на кшталт Anki незручні. Вони потужні, але вимагають купу налаштувань, не нагадують коли треба повторити і виглядають як з минулого століття.",
  about_paragraph_2:
    "На конкурсі міні-додатків Telegram я зробив картки, про які мріяв. Нічого налаштовувати не треба, розумні нагадування вже є, інтерфейс простий і зрозумілий.",
  about_paragraph_3:
    "В основі - перевірений науковий метод інтервального повторення Еббінгауза. Картки з'являються саме тоді, коли ви починаєте забувати - так запам'ятовується найкраще.",
  about_paragraph_4:
    "MemoCard виграв приз на конкурсі. Зараз ним користуються тисячі людей по всьому світу.",
  about_visit_website: "Відвідати сайт →",
  about_github_frontend: "GitHub репозиторій фронтенду →",

  // Card Input Mode Form
  card_input_mode_form_title: "Назва",
  card_input_mode_form_ai_prompt: "AI запит",
  card_input_mode_form_create_title: "Створити режим введення",
  card_input_mode_form_edit_title: "Редагувати режим введення",
  card_input_mode_form_delete_confirm: "Видалити цей режим введення?",
  card_input_mode_add_button: "Додати режим введення",
  card_input_mode_form_title_placeholder: "напр. Англійські визначення",
  card_input_mode_form_prompt_placeholder:
    "напр. Створи картку визначення для слова :template_word",
  card_input_mode_form_front_placeholder: "напр. Слово або термін",
  card_input_mode_form_back_placeholder: "напр. Просте визначення",
  card_input_mode_form_example_placeholder:
    "напр. Приклад використання або контекст",
  card_input_mode_form_save_success: "Режим введення збережено",
  card_input_mode_form_delete_success: "Режим введення видалено",
  quit_card: "Закрити картку",

  // Wysiwyg Help
  wysiwyg_help_title: "Як форматувати текст",
  wysiwyg_help_step1: "Виділіть текст, який хочете змінити",
  wysiwyg_help_step2: "Натисніть будь-яку кнопку на панелі інструментів",
  wysiwyg_help_bold: "Жирний текст",
  wysiwyg_help_italic: "Курсивний текст",
  wysiwyg_help_color: "Змінити колір тексту",
  wysiwyg_help_heading: "Збільшити текст (заголовок)",
  wysiwyg_help_table: "Вставити таблицю",
  wysiwyg_help_clear: "Видалити все форматування",
  wysiwyg_help_undo: "Скасувати останню дію",

  reverse_cards: "Зворотні картки",
  reverse_cards_title: "Зворотні картки",
  reverse_cards_helper:
    "Створи одну - отримай дві. Допомагає краще запам'ятовувати",
  two_cards_created: "Створено 2 картки",
  card_created: "Картку створено",

  // Move card to deck
  move_card_to_deck_title: "Перемістити в колоду",
  move_card_without_folder: "Без папки",
  move_card_move: "Перемістити",
  move_card_open_deck: "Відкрити колоду",

  // Image related
  image: "Зображення",

  // Skip card
  skip_card_for_now: "Пропустити",
  skip_card_confirm: "Пропустити цю картку? Вона буде прихована до наступного повторення",
  review_skipped: "Пропущено",
};
